import requestFunctions from "../../functions/requestFunctions";


export const state = {
  OPERATORS_TARIFFS_ITEM: {},
  OPERATORS_TARIFFS_LIST: [],
  OPERATORS_TARIFFS_TABLE_DATA: [],
  OPERATORS_TARIFFS_LIST_DATA: [],
  OPERATORS_TARIFFS_TOTAL_ROWS: 0
}

export const getters = {
  GET_OPERATORS_TARIFFS_ITEM: (state) => {
    return state.OPERATORS_TARIFFS_ITEM;
  },
  GET_OPERATORS_TARIFFS_LIST_DATA: (state) => {
    return state.OPERATORS_TARIFFS_LIST_DATA;
  },
  GET_OPERATORS_TARIFFS_TABLE_DATA: (state) => {
    return state.OPERATORS_TARIFFS_TABLE_DATA;
  },
  GET_OPERATORS_TARIFFS_TOTAL_ROWS: (state) => {
    return state.OPERATORS_TARIFFS_TOTAL_ROWS;
  }
}

export const mutations = {
  UPDATE_OPERATORS_TARIFFS_ITEM(state, item) {
    state.OPERATORS_TARIFFS_ITEM = item;
  },
  UPDATE_OPERATORS_TARIFFS_LIST(state, list) {

    state.OPERATORS_TARIFFS_LIST = list.data;
    state.OPERATORS_TARIFFS_TOTAL_ROWS = list.total;

    list = list.data;

    state.OPERATORS_TARIFFS_TABLE_DATA = [];
    state.OPERATORS_TARIFFS_LIST_DATA = [];

    list.forEach(el => {

      let status = '';

      if(el.status === 'active'){
        status = 'Активный'
      }
      if(el.status === 'wait'){
        status = 'Ожидает активации'
      }
      if(el.status === 'disabled'){
        status = 'Отключен'
      }

      let unit = '';

      if(el.unit === 'minutes'){
        unit = 'Минуты'
      }
      if(el.unit === 'seconds'){
        unit = 'Секунды'
      }
      if(el.unit === 'symbols'){
        unit = 'Символы'
      }

      state.OPERATORS_TARIFFS_TABLE_DATA.push({
        'id'     : el.id ? el.id : null,
        'name'   : el.name ? el.name : null,
        'product_name'  : el.product_name ? el.product_name : null,
        'operator_name' : el.operator_name ? el.operator_name : null,
        'rate'   : (el.rate ? el.rate : '') + ' руб.',
        'qnt'    : el.qnt ? el.qnt : null,
        'unit'   : unit,
        'status' : status,
        'uuid'   : el.uuid ? el.uuid : null
      });

      let config = null;
      if(el.config){
        config = JSON.parse(el.config);
      }

      state.OPERATORS_TARIFFS_LIST_DATA.push({
        id   : el.id   ? el.id   : null,
        name : el.name ? el.name : null,
        operator_name : el.operator_name ? el.operator_name : null,
        operator_code : el.operator_code ? el.operator_code : null,
        operator_uuid : el.operator_uuid ? el.operator_uuid : null,
        model         : config && config.model ? config.model : null,
        voice_id      : config && config.id ? config.id : null,
        languages     : config && config.languages ? config.languages : [],
        emotions      : config && config.emotion ? config.emotion : [],
      });

    });
  },
}


export const actions = {

  async FETCH_OPERATORS_TARIFFS_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/operators/tariffs/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_OPERATORS_TARIFFS_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_OPERATORS_TARIFFS_LIST({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/operators/tariffs';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_OPERATORS_TARIFFS_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_OPERATORS_TARIFFS_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/operators/tariffs';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_OPERATORS_TARIFFS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/operators/tariffs/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_OPERATORS_TARIFFS_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/operators/tariffs/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}